// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"afeae7dd","453":"87d4d1e7"}[chunkId] + ".chunk.js";
};